import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';


const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    height: 35,
    backgroundColor: theme.palette.error.main,
  },
  message: {
    padding: theme.spacing.unit,
  },
});

class StripWarning extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };

    }

    render() {
        const { classes, view, appEnv } = this.props;

        return (
            <Paper className={classes.root}>
                <Typography className={classes.message}>{`PAYMENT IS IN TEST | App Env: ${appEnv}`}</Typography>
            </Paper>
        )
    }

}

StripWarning.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StripWarning);



// WEBPACK FOOTER //
// ./src/components/lib/StripeWarning.js